export enum BazaDwollaPaymentChannel {
    Balance = 'balance',
    ACH = 'ach',
}
